// Panel dédié OpenAI Codex — pattern network (1 fichier fin par CLI).
import type { Component } from "solid-js";
import { registerPanel } from "@/panel-registry";
import { CliPanel } from "./cli/cli-panel";

const CodexCliPanel: Component = () => <CliPanel cli="codex" />;

registerPanel("cli-codex", CodexCliPanel);
export default CodexCliPanel;
